module.exports = "/_next/static/images/John_Winder-fdbf832c3fde30d2eb15420662fae80b.webp";